// Match the runtime adapters: a valid reference wins over a legacy name.
export function effectiveFieldName(item, fields, isStep) {
  const referenceKey = isStep ? 'outputFieldRef' : 'dataFieldRef';
  const referenced = fields?.find(field => field.id === item[referenceKey]);
  return referenced
    ? (referenced.fieldName || referenced.id)
    : (isStep ? item.output || item.dataField : item.dataField) || '';
}

export function initializeFieldBinding(item, fields, isStep) {
  return { ...item, [isStep ? 'output' : 'dataField']: effectiveFieldName(item, fields, isStep) };
}

export function bindConfigurationField(data, fieldKey, fieldRef) {
  if (!fieldKey || !fieldRef) return data;
  const binding = { [fieldKey === 'output' ? 'outputFieldRef' : 'dataFieldRef']: fieldRef.id };
  const versions = data.versions;
  return {
    ...data,
    ...binding,
    // Only the newly appended snapshot describes this save. Never rewrite history.
    ...(versions?.length ? { versions: [
      ...versions.slice(0, -1),
      { ...versions[versions.length - 1], [fieldKey]: data[fieldKey], ...binding },
    ] } : {}),
  };
}
